module.exports = __webpack_public_path__ + "img/ba.d1e412e9.svg";